import { URLS } from './urls';

const APPS_PREFIX = `apps(-beta)?`;

export const PARAMS = {
	PAGE: ':page',
	GENRE: ':genre',
	APP_ID: ':appId',
};

export const ROUTES = {
	PAYMENT_RESULT: `${URLS.PAYMENT_RESULT}`,
	APP: `/${APPS_PREFIX}\(/promo)?\/${PARAMS.APP_ID}(\[0-9]+\)`,
	MAIN: URLS.MAIN,
	CATALOG: `/${APPS_PREFIX}`,
	CATALOG_NEW: `/${APPS_PREFIX}${URLS.CATALOG_NEW}/${PARAMS.PAGE}?`,
	CATALOG_GENRE: `/${APPS_PREFIX}\(/promo)?\/${PARAMS.GENRE}(\[a-zA-Z]+[a-zA-Z0-9_-]*\)/${PARAMS.PAGE}?`,
	CATALOG_POPULAR: `/${APPS_PREFIX}${URLS.CATALOG_POPULAR}`,
	CATALOG_INSTALLED: `/${APPS_PREFIX}${URLS.CATALOG_INSTALLED}${PARAMS.PAGE}?`,
};
